import { render } from "./MpfSettingEdit.vue?vue&type=template&id=bf3b1788"
import script from "./MpfSettingEdit.vue?vue&type=script&lang=js"
export * from "./MpfSettingEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__